import React from "react";
import ResetComponent from "../../components/forms/Reset";
import img1 from "../../assets/images/img1.png";
import img2 from "../../assets/images/img2.png";
import logo from "../../assets/images/CoreVentum_logo_dark.png";;
function Reset() {
  return (
    <div
      className="h-screen w-full bg-cover bg-center flex flex-col md:flex-row relative" style={{ backgroundImage: `url(${img2})` }}>
      <nav className="p-3 absolute top-0 left-0">  <img src={logo} alt="logo" width={150} />  </nav>
      <div className="hidden md:block w-full md:w-1/2 p-6 pl-12 pt-20">
        <h1 className="text-white font-bold text-lg md:text-xl lg:text-2xl mb-4">
          Contract Life-Cycle Management Software (CLMS)
        </h1>
        <img src={img1} alt="CLMS Banner" className="w-full max-w-xl " />
      </div>
      <div className="flex justify-center items-center w-full md:w-1/2 p-4 z-20">
        <ResetComponent />
      </div>
    </div>
  );
}

export default Reset;
